import React from 'react'
import './index.less'

// 定义列表项的数据类型
interface InfoItem {
  name: string
  purpose: string
  scenario: string
  status: string
}

// 表头配置
// const columns = ['信息名称', '使用目的', '使用场景', '收集情况']
const columns = ['信息名称', '使用目的', '使用场景']

// 列表数据
const infoList: InfoItem[] = [
  { name: '姓名', purpose: '实名认证', scenario: '进行实名认证时', status: '已收集0条' },
  { name: '性别', purpose: '完善账号基本资料', scenario: '用户填写并提交时;资料展示时', status: '已收集1条' },
  { name: '年龄', purpose: '完善账号基本资料', scenario: '用户填写并提交时;资料展示时', status: '已收集1条' },
  { name: '城市', purpose: '完善账号基本资料', scenario: '用户填写并提交时;资料展示时', status: '已收集1条' },
  { name: '账号名', purpose: '注册/登录小香风账号;安全风控', scenario: '注册/登录小香风账号时;资料展示时', status: '已收集1条' },
  { name: '登录密码', purpose: '注册/登录小香风账号;安全风控', scenario: '注册/登录小香风账号时;设置/修改/找回登录密码时', status: '已收集1条' },
  { name: '账号绑定手机号码', purpose: '注册/登录/绑定小香风账号时;安全风控;实名认证', scenario: '注册/登录/绑定小香风账号时;进行实名认证时;身份验证时;商业化推广/调研时', status: '已收集1条' },
  { name: '头像', purpose: '完善网络身份标识', scenario: '上传头像时;第三方账号登录时;资料展示时', status: '已收集1条' },
  { name: '昵称', purpose: '完善网络身份标识', scenario: '上传头像时;第三方账号登录时;资料展示时', status: '已收集1条' },
  { name: '身份证件信息', purpose: '实名认证', scenario: '用户进行实名认证时', status: '已收集0条' },
  { name: '联系人信息手机号', purpose: '给用户兑现奖励/回复用户咨询', scenario: '用户每次填写或提交手机号时', status: '已收集0条' },
  { name: '位置信息', purpose: '提供正确的软件版本、连接至正确的服务器；安全风控', scenario: '用户下载/安装/更新软件时；用户每次打开APP时；判断安全风控事件时', status: '已收集0条' },
  { name: '订单记录', purpose: '订单管理和查看', scenario: '用户每次提交订单时', status: '已收集0条' },
  { name: '设备标识信息(OAID, 及必要的设备标识补充信息)', purpose: '设备标识信息(OAID, 及必要的设备标识补充信息)', scenario: '用于设备识别、风险防控、反作弊、识别异常设备、防范滥发行为、保障账号与业务安全', status: '已收集0条' },
]

const PersonInfoCollectList: React.FC = () => {
  return (
    <div className='person-info-collect-list'>
      <table className='info-table'>
        <thead>
          <tr>
            {columns.map(col => (
              <th key={col}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {infoList.map((item, index) => (
            <tr key={index}>
              <td>{item.name}</td>
              <td>{item.purpose}</td>
              <td>{item.scenario}</td>
              {/* <td>{item.status}</td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default PersonInfoCollectList